import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { API_KEY_BASE_PATH } from '../../../../features/api-auth/api-key-routing';

export const Route = createFileRoute('/_app/developer/api-key/_api-key')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'api-key',
        label: 'Developers',
        to: API_KEY_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
